import { questionnaireConstants as constants } from '../_constants/questionnaire.constants';
import { List } from 'immutable';

export const initialState = {
  collection: { data: [] },
  current: {
    resourceType: 'Questionnaire',
    meta: {
      profile: [
        "https://axshealthapp.com/fhir/StructureDefinition/Questionnaire"
      ]
    },
    extension: [
      {
        url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-signatureRequired',
        valueBoolean: false
      },
      {
        url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-patientType',
        extension: [
          {
            url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-new-patient',
            valueBoolean: false
          },
          {
            url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-established-patient',
            valueBoolean: false
          },
          {
            url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-workers-compensation',
            valueBoolean: false
          }
        ]
      },
      {
        url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-appointmentType',
        extension: [
          {
            url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-axs-links',
            valueBoolean: false
          },
          {
            url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-telehealth',
            valueBoolean: false
          }
        ]
      }
    ],
    status: 'draft',
    title: '',
    item: [],
  },
  noteTemplate: '',
  notePreview: '',
  noteWarning: false,
  answers: [],
  editQuestion: false,
  isSaving: false,
  isLoading: false,
  saveSuccess: false,
  id: null
}

export function questionnaire(state = initialState, action) {
  if (action.type === constants.QUESTIONNAIRE_RESET_IDS) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item, i) => {
          return { ...item, linkId: (i + 1).toString() }
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_MOVE_ITEMS) {
    const itemsCopy = List(state.current.item);

    let toArrayPosition = parseInt(action.toHumanPosition) - 1;

    if (toArrayPosition < 0) {
      toArrayPosition = 0;
    }

    if (toArrayPosition > (itemsCopy.size - 1)) {
      toArrayPosition = itemsCopy.size - 1;
    }

    const movingItem = itemsCopy.get(action.fromIndexPosition);
    const arranged = itemsCopy.splice(action.fromIndexPosition, 1)
      .splice(toArrayPosition, 0, movingItem);
    return {
      ...state,
      editQuestion: false,
      current: {
        ...state.current,
        item: arranged.toArray().map((item, i) => {
          return { ...item, linkId: (i + 1).toString() }
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_REARRANGE_ITEMS) {
    const itemsCopy = List(state.current.item);
    const movingItem = itemsCopy.get(action.from);
    const arranged = itemsCopy.splice(action.from, 1)
      .splice(action.to, 0, movingItem);

    return {
      ...state,
      editQuestion: false,
      current: {
        ...state.current,
        item: arranged.toArray()
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_SIGNATURE) {
    const extensionExists = state.current.extension.find(extension => {
      return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-signatureRequired';
    });

    if (extensionExists) {
      return {
        ...state,
        current: {
          ...state.current,
          extension: state.current.extension.map(extension => {
            if (extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-signatureRequired') {
              extension.valueBoolean = action.signature;
            }

            return extension;
          })
        }
      }
    } else {
      return {
        ...state,
        current: {
          ...state.current,
          extension: [
            ...state.current.extension,
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-signatureRequired',
              valueBoolean: action.signature
            }
          ]
        }
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_APPOINTMENT_TYPE) {
    return {
      ...state,
      current: {
        ...state.current,
        extension: state.current.extension.map((extentionType) => {
          if (extentionType.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-appointmentType') {
            return {
              ...extentionType,
              extension: extentionType.extension.map((appointmentType) => {
                if (appointmentType.url === `https://axshealthapp.com/fhir/StructureDefinition/questionnaire-${action.appointmentType}`) {
                  return {
                    url: `https://axshealthapp.com/fhir/StructureDefinition/questionnaire-${action.appointmentType}`,
                    valueBoolean: !appointmentType.valueBoolean
                  }
                }

                return appointmentType;
              })
            }
          }

          return extentionType;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_PATIENT_TYPE) {
    return {
      ...state,
      current: {
        ...state.current,
        extension: state.current.extension.map((extentionType) => {
          if (extentionType.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-patientType') {
            return {
              ...extentionType,
              extension: extentionType.extension.map((patientType) => {
                if (patientType.url === `https://axshealthapp.com/fhir/StructureDefinition/questionnaire-${action.patientType}`) {
                  return {
                    url: `https://axshealthapp.com/fhir/StructureDefinition/questionnaire-${action.patientType}`,
                    valueBoolean: !patientType.valueBoolean
                  }
                }

                return patientType;
              })
            }
          }

          return extentionType;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_GET_SUCCESS) {
    return {
      ...state,
      id: action.questionnaire.id,
      current: action.questionnaire.resource,
      noteTemplate: action.questionnaire.noteTemplate
    }
  }

  if (action.type === constants.QUESTIONNAIRE_GETALL_FAILURE) {
    return {
      ...state,
      isLoading: false
    }
  }

  if (action.type === constants.QUESTIONNAIRE_GETALL_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      collection: action.collection
    }
  }

  if (action.type === constants.QUESTIONNAIRE_GETALL_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SAVE_FAILURE) {
    return {
      ...state,
      isSaving: false
    }
  }

  if (action.type === constants.QUESTIONNAIRE_INIT_STATE) {
    return initialState;
  }

  if (action.type === constants.QUESTIONNAIRE_SAVE_SUCCESS) {
    return {
      ...initialState,
      saveSuccess: true
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SAVE_REQUEST) {
    return {
      ...state,
      isSaving: true
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_NOTE_TEMPLATE) {
    return {
      ...state,
      noteTemplate: action.noteTemplate
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_NOTE_PREVIEW) {
    return {
      ...state,
      notePreview: action.notePreview
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_SUPPORT_IMAGE) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            const supportImage = item.extension.find((extension) => {
              return extension.url === 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage'
            });

            if (supportImage) {
              return {
                ...item,
                extension: item.extension.map((extension) => {
                  if (extension.url === 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage') {
                    return {
                      url: 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage',
                      valueUri: action.url
                    }
                  }
                  return extension;
                })
              }
            } else {
              return {
                ...item,
                extension: [
                  ...item.extension,
                  {
                    url: 'https://www.axshealthapp.com/fhir/StructureDefinition/questionnaire-supportImage',
                    valueUri: action.url
                  },
                ]
              }
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_CHOICE_TYPE) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            return {
              ...item,
              extension: item.extension.map((extension) => {
                if (extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl') {
                  return {
                    url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
                    valueCodeableConcept: {
                      coding: [{
                        system: 'http://hl7.org/fhir/questionnaire-item-control',
                        code: action.choiceType
                      }]
                    }
                  }
                }

                return extension;
              })
            };
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_ANSWER_QUESTION) {
    const exists = state.answers.find((answer) => {
      return answer.linkId === action.item.linkId;
    })

    if (exists) {
      return {
        ...state,
        answers: state.answers.map((answer) => {
          if (answer.linkId === action.item.linkId) {
            return { linkId: action.item.linkId, answer: action.answer }
          }

          return answer;
        })
      }
    } else {
      return {
        ...state,
        answers: [
          ...state.answers,
          { linkId: action.item.linkId, answer: action.answer }
        ]
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_SUPPORT_LINK) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            const supportLinkExists = item.extension.find((extension) => {
              return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink'
            });

            if (supportLinkExists) {
              return {
                ...item,
                extension: item.extension.map((extension) => {
                  if (extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink') {
                    return {
                      url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink',
                      valueUri: action.url
                    }
                  }
                  return extension;
                })
              }
            } else {
              return {
                ...item,
                extension: [
                  ...item.extension,
                  {
                    url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-supportLink',
                    valueUri: action.url
                  },
                ]
              }
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_UPDATE_OPTION) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            return {
              ...item,
              answerOption: item.answerOption.map((option, i) => {
                if (i === action.position) {
                  return {
                    valueCoding: {
                      code: action.option
                    }
                  }
                }

                return option;
              })
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_REMOVE_OPTION) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            return {
              ...item,
              answerOption: item.answerOption.filter((option) => {
                return option.valueCoding.code !== action.option.valueCoding.code;
              })
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_ADD_OPTION) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            return {
              ...item,
              answerOption: [
                ...item.answerOption,
                {
                  valueCoding: {
                    code: action.option
                  }
                }
              ]
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_EDIT_QUESTION) {
    return {
      ...state,
      editQuestion: action.item.linkId
    }
  }

  if (action.type === constants.QUESTIONNAIRE_MARK_AS_REQUIRED) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            return Object.assign({}, item, {
              required: action.required
            });
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_MARK_AS_NOTE) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            return {
              ...item,
              extension: item.extension.map((extension) => {
                if (extension.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note') {
                  return {
                    url: 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note',
                    valueBoolean: action.note
                  }
                }

                return extension;
              })
            }
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_EDIT_TITLE) {
    return {
      ...state,
      editQuestion: false,
      current: {
        ...state.current,
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_TITLE) {
    return {
      ...state,
      current: {
        ...state.current,
        title: action.title
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_ITEM_TEXT) {
    return {
      ...state,
      current: {
        ...state.current,
        item: state.current.item.map((item) => {
          if (item.linkId === action.item.linkId) {
            return Object.assign({}, item, {
              text: action.text
            });
          }

          return item;
        })
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_ADD_ITEM) {
    const linkId = (state.current.item.length + 1).toString();

    return {
      ...state,
      editQuestion: linkId,
      current: {
        ...state.current,
        item: [
          ...state.current.item,
          Object.assign({}, action.question, { linkId })
        ],
      }
    }
  }

  if (action.type === constants.QUESTIONNAIRE_SET_WARNING) {
    return {
      ...state,
      noteWarning: true
    }
  }

  if (action.type === constants.QUESTIONNAIRE_REMOVE_ITEM) {
    return {
      ...state,
      editQuestion: false,
      noteWarning: true,
      answers: state.answers.filter((answer) => {
        return answer.linkId !== action.item.linkId;
      }).map((item, i) => {
        if (parseInt(item.linkId) > parseInt(action.item.linkId)) {
          const newLinkId = parseInt(item.linkId) - 1;

          return {
            ...item,
            linkId: newLinkId.toString(),
          };
        }

        return item;
      }),
      current: {
        ...state.current,
        item: state.current.item.filter((item) => {
          return item.linkId !== action.item.linkId;
        }).map((item, i) => {
          return { ...item, linkId: (i + 1).toString() }
        })
      }
    }
  }

  return state;
}